module.exports = __webpack_public_path__ + "static/img/delete.6a0b6cd2.png";